module.exports = __webpack_public_path__ + "img/247.8ff0ef64.png";